import { render, staticRenderFns } from "./directoryList.vue?vue&type=template&id=527105e4&scoped=true&lang=html&"
import script from "./directoryList.vue?vue&type=script&lang=js&"
export * from "./directoryList.vue?vue&type=script&lang=js&"
import style0 from "./directoryList.vue?vue&type=style&index=0&id=527105e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527105e4",
  null
  
)

export default component.exports